import Typography, { TypographyColor } from '@/components/typography';

export type StatisticProps = {
  amount?: string;
  unit?: string;
  label?: string;
};

export default function Statistic({ amount, unit, label }: StatisticProps) {
  return (
    <div className='flex h-full flex-col items-center px-4 text-center'>
      <Typography.Display3
        color={TypographyColor.PRIMARY}
        className='!break-normal'
        inline
      >
        {amount}
        {unit}
      </Typography.Display3>
      <Typography.Body1>{label}</Typography.Body1>
    </div>
  );
}
